const AndorraSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_110738)">
      <path
        d="M11.3041 38.0155C13.9335 39.2869 16.8832 40 19.9997 40C23.1162 40 26.066 39.2869 28.6953 38.0155L30.4345 20L28.6953 1.98453C26.066 0.713125 23.1162 0 19.9997 0C16.8832 0 13.9335 0.713125 11.3041 1.98453L9.56494 20L11.3041 38.0155Z"
        fill="#FFDA44"
      />
      <path
        d="M28.6958 38.0149C35.3857 34.78 40.0002 27.9293 40.0002 20.0001C40.0002 12.071 35.3857 5.2202 28.6958 1.98535V38.0149Z"
        fill="#D80027"
      />
      <path
        d="M11.3044 38.0149V1.98535C4.61445 5.2202 0 12.0709 0 20.0001C0 27.9293 4.61445 34.78 11.3044 38.0149Z"
        fill="#0052B4"
      />
      <path
        d="M20 26.9565C20 23.765 20 20 20 20H25.2174V22.6087C25.2174 23.0619 24.3479 24.7225 22.2016 26.087C21.3887 26.6038 20.5472 26.7701 20 26.9565Z"
        fill="#D80027"
      />
      <path d="M14.7827 14.7832H20.0001V20.0006H14.7827V14.7832Z" fill="#D80027" />
      <path
        d="M22.6086 13.0438C22.6086 12.0833 21.8299 11.3047 20.8695 11.3047C20.5523 11.3047 20.2559 11.3909 19.9999 11.5392C19.7439 11.3909 19.4476 11.3047 19.1304 11.3047C18.1699 11.3047 17.3913 12.0833 17.3913 13.0438H13.0435V21.7394C13.0435 24.9766 15.6142 26.8487 17.6303 27.8191C17.4794 28.0768 17.3913 28.3758 17.3913 28.696C17.3913 29.6566 18.1699 30.4352 19.1304 30.4352C19.4476 30.4352 19.744 30.3489 19.9999 30.2006C20.256 30.3489 20.5523 30.4352 20.8695 30.4352C21.8299 30.4352 22.6086 29.6566 22.6086 28.696C22.6086 28.3758 22.5205 28.0768 22.3696 27.8191C24.3856 26.8487 26.9564 24.9766 26.9564 21.7394V13.0438H22.6086ZM24.3478 21.7394C24.3478 22.1926 24.3478 23.5716 22.2015 24.9361C21.3885 25.453 20.5471 25.7881 19.9999 25.9745C19.4528 25.7881 18.6113 25.453 17.7984 24.9361C15.6521 23.5716 15.6521 22.1926 15.6521 21.7394V15.6525H24.3478V21.7394Z"
        fill="#FF9811"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110738">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AndorraSvg;
